import React from 'react';
import UserAvatar from '../common/UserAvatar';

const tableConfig = (props) => ({
    columns: [
        {
            title: 'Date', field: 'date', filterAndSearch: false, width: "100px",

        },
        {
            title: 'Sales Amount', field: 'salesAmount', filterAndSearch: false,
            render: rowData => <div>{(rowData.currency === "&#8377;") ? <span>&#8377;{rowData.salesAmount}</span> : <span>&#36;{rowData.salesAmount}</span>}</div>
        },
        {
            title: 'Tax', field: 'taxAmount', filterAndSearch: false,
            render: rowData => <div>{(rowData.currency === "&#8377;") ? <span>&#8377;{rowData.taxAmount}</span> : <span>&#36;{rowData.taxAmount}</span>}</div>
        },
        // {
        //     title: 'Shipping Charges', field: 'shippingCharges', filterAndSearch: false,
        //     render: rowData => <div>{(rowData.currency === "&#8377;") ? <span>&#8377;{rowData.shippingCharges}</span> : <span>&#36;{rowData.shippingCharges}</span>}</div>
        // },
        {
            title: 'Delivery Charges', field: 'deliveryCharges', filterAndSearch: false,
            render: rowData => <div>{(rowData.currency === "&#8377;") ? <span>&#8377;{rowData.deliveryCharges}</span> : <span>&#36;{rowData.deliveryCharges}</span>}</div>
        },
        {
            title: 'COD Received Amount', field: 'codReceivedAmount', filterAndSearch: false,
            render: rowData => <div>{(rowData.currency === "&#8377;") ? <span>&#8377;{rowData.codReceivedAmount}</span> : <span>&#36;{rowData.codReceivedAmount}</span>}</div>
        },
        {
            title: 'Amount To Settle', field: 'amountToSettle', filterAndSearch: false,
            render: rowData => <div>{(rowData.currency === "&#8377;") ? <span>&#8377;{rowData.amountToSettle}</span> : <span>&#36;{rowData.amountToSettle}</span>}</div>
        },
        /*{ title: 'Extra Received', field: 'extraReceived', filterAndSearch: false,
         render:rowData=><div>{( rowData.currency === "&#8377;") ? <span>&#8377;{rowData.extraReceived}</span> : <span>&#36;{rowData.extraReceived}</span>}</div>
        },*/
        {
            title: 'Final Amount To Settle', field: 'finalAmountToSettle', filterAndSearch: false,
            render: rowData => <div>{(rowData.currency === "&#8377;") ? <span>&#8377;{rowData.finalAmountToSettle}</span> : <span>&#36;{rowData.finalAmountToSettle}</span>}</div>
        },
        { title: 'Settlement Status', field: 'settlementStatus', filterAndSearch: false }

    ],
})

export const data = [
    {
        "userId": "rirani",
        "jobTitleName": "Developer",
        "firstName": "Romin",
        "lastName": "Irani",
        "preferredFullName": "Romin Irani",
        "employeeCode": "E1",
        "region": "CA",
        "phoneNumber": "408-1234567",
        "emailAddress": "romin.k.irani@gmail.com"
    },
    {
        "userId": "nirani",
        "jobTitleName": "Developer",
        "firstName": "Neil",
        "lastName": "Irani",
        "preferredFullName": "Neil Irani",
        "employeeCode": "E2",
        "region": "CA",
        "phoneNumber": "408-1111111",
        "emailAddress": "neilrirani@gmail.com"
    },
    {
        "userId": "thanks",
        "jobTitleName": "Program Directory",
        "firstName": "Tom",
        "lastName": "Hanks",
        "preferredFullName": "Tom Hanks",
        "employeeCode": "E3",
        "region": "CA",
        "phoneNumber": "408-2222222",
        "emailAddress": "tomhanks@gmail.com"
    },
    {
        "userId": "thankss",
        "jobTitleName": "Program Directorys",
        "firstName": "Toms",
        "lastName": "Hankss",
        "preferredFullName": "Tom Hanksss",
        "employeeCode": "E3s",
        "region": "CAs",
        "phoneNumber": "408-22222222",
        "emailAddress": "tomhanks@gmail.coms"
    }
];

export default tableConfig;
